module.exports = __webpack_public_path__ + "cc696cc346b41fc866b70b13e50d81e1.pdf";